var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "avatar--path-1",
    cx: 13.4615385,
    cy: 13.4615385,
    r: 13.4615385
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "avatar--path-3",
    points: "0 0.0138457167 10.0786156 0.0138457167 10.0786156 4.2790932 0 4.2790932"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "avatar--EID---AZ-Analytics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "avatar--ADSA---Table-loading",
    transform: "translate(-30.000000, -208.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "avatar--avatar",
    transform: "translate(30.000000, 208.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "avatar--Oval",
    stroke: "#BEC4D0",
    strokeWidth: 1.07692308,
    fill: "#F7F8FA",
    cx: 14,
    cy: 14,
    r: 13.4615385
  }), /*#__PURE__*/React.createElement("g", {
    id: "avatar--Group-6",
    strokeWidth: 1,
    transform: "translate(0.538462, 0.538462)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "avatar--mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#avatar--path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "avatar--Mask",
    fill: "#F7F8FA",
    xlinkHref: "#avatar--path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#avatar--mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.615385, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.86135352,6.61365385 C6.68799685,6.61365385 8.16980769,5.13509719 8.16980769,3.3084535 C8.17143293,1.4818098 6.69125,0.00162657497 4.86460667,0 C3.03796335,0 1.55778042,1.47855665 1.55615385,3.30520035 L1.55615385,3.3084535 C1.55778042,5.13347062 3.03633677,6.61365385 4.86135352,6.61365385",
    id: "avatar--Fill-1",
    fill: "#BEC4D0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "avatar--Group-5",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(0.000000, 8.092000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "avatar--mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#avatar--path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "avatar--Clip-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.04838909,0.0138457167 C2.75417371,0.0154950777 0.722837167,1.54775143 0.0170472949,3.80737597 C-0.0419012949,3.99705248 0.0568774231,4.19992388 0.238502808,4.26095023 C0.273553321,4.27414512 0.311790244,4.2790932 0.348433962,4.2790932 L9.6814296,4.2790932 C9.90129191,4.2790932 10.0797309,4.09436478 10.0797309,3.86675296 C10.0797309,3.82222021 10.0717649,3.77603811 10.057426,3.73315472 C9.33092447,1.51146548 7.31551999,0.0154950777 5.04838909,0.0138457167",
    id: "avatar--Fill-3",
    fill: "#BEC4D0",
    mask: "url(#avatar--mask-4)"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/default-avatar.936684946cfaac385ed70eee3236ca27.svg";
export { ForwardRef as ReactComponent };